module.exports = __webpack_public_path__ + "files/a426ec40e7f739f5c320844c43c099ea.png";